import styled from 'styled-components';

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 360px;
`;

export const NodeContext = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px;
  background: ${({ theme: { colors = {} } }) =>
    colors.surfaceContainerLowest ?? '#07080F'};
  border: 1px solid
    ${({ theme: { colors = {} } }) => colors.outlineVariant ?? '#25263A'};
  border-radius: ${({ theme: { borderRadius = {} } }) =>
    borderRadius.small ?? '6px'};
`;

export const NodeLabel = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme: { colors = {} } }) => colors.onSurface ?? '#E6E6F2'};
`;

export const Explanation = styled.div`
  font-size: 12px;
  color: ${({ theme: { colors = {} } }) => colors.onSurfaceVariant ?? '#9A95B0'};
  line-height: 1.5;
`;

export const RoleHint = styled.div`
  font-size: 11px;
  color: ${({ theme: { colors = {} } }) => colors.onSurfaceVariant ?? '#9A95B0'};
  font-style: italic;
`;
